
import React, { useState, useEffect, useRef } from 'react';
import { Checkbox } from 'antd';

const ColumnSelectionModal = ({
  isVisible,
  onClose,
  baseColumns,
  visibleColumns,
  onColumnChange,
  triggerElement,
  isOgmSubsTable = false,
  isSubRepositoriesScreen=false,
  isManageOutsScreen=false,
  isViewDropOutVisible = false 
}) => {
  console.log('ColumnSelectionModal rendered with:', { isVisible, baseColumns, visibleColumns, isOgmSubsTable, isViewDropOutVisible });

  const [selectedColumns, setSelectedColumns] = useState([]);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [modalPosition, setModalPosition] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    setSelectedColumns(visibleColumns);
  }, [visibleColumns, isVisible]);

    useEffect(() => {
    if (isVisible && triggerElement) {
      const rect = triggerElement.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

      let top, left;
      const modalWidth = 220;
      if (isOgmSubsTable) {
        top = rect.bottom + scrollTop - 95;
        left = rect.right + scrollLeft - 240;
      } else if (isSubRepositoriesScreen) {
        top = rect.bottom + scrollTop - 100;
        left = rect.right + scrollLeft - modalWidth;
      } else {
        top = rect.bottom + scrollTop + 5;
        left = rect.right + scrollLeft - 220;
      }
      
      setPosition({ top, left });
      setModalPosition(true); // <-- set modalPosition true when ready
    } else {
      setModalPosition(false); // <-- reset when not visible
    }
  }, [isVisible, triggerElement, isOgmSubsTable, isSubRepositoriesScreen]);

  if (!isVisible || !modalPosition) return null;

  const handleColumnToggle = (columnKey, checked) => {
    let updatedColumns;
    if (checked) {
      updatedColumns = [...selectedColumns, columnKey];
    } else {
      updatedColumns = selectedColumns.filter(key => key !== columnKey);
    }
   
    // Ensure Actions column is always included
    const finalColumns = [...new Set([...updatedColumns, 'ruleType', 'Actions'])];
   
    setSelectedColumns(finalColumns);
    onColumnChange(finalColumns);
  };

  const getColumnTitle = (column) => {
    // ManageOuts columns
    if (column.dataIndex === 'ruleType') return 'Actions';
    if (column.dataIndex === 'endDate') return 'End Date';
    if (column.dataIndex === 'cutoff') return 'Cut Off';
    if (column.dataIndex === 'totalOuts') return 'Total Outs';
    if (column.dataIndex === 'site') return 'Site ID';
    if (column.dataIndex === 'nationalId') return 'Group/Ship To';
    if (column.dataIndex === 'originalItem') return 'Original Item';
    if (column.dataIndex === 'asoh') return 'ASOH';
    if (column.dataIndex === 'totalOrders') return 'Total Orders';
    
    // ManageSubs columns
    if (column.dataIndex === 'substituteItem') return 'Substitute Item';
    if (column.dataIndex === 'subRatio') return 'Sub Ratio/ Reason Code';
    if (column.dataIndex === 'endDate') return 'End Date';
    if (column.dataIndex === 'modifiedByName') return 'Last Modified';
    if (column.dataIndex === 'customerApprovalFlag') return 'Cust APV';
    
    // OGM Subs specific columns
    if (column.dataIndex === 'lastOrderDate') return 'Last Order Date';
    if (column.dataIndex === 'customerApprovalFlag') return 'Cust APV';
    
    // Maintain Accounts specific columns
    if (column.dataIndex === 'accountType') return 'L/C';
    if (column.dataIndex === 'inclusionExclusion') return 'Inc/Exc';
    if (column.dataIndex === 'requestApproval') return 'Req Apv';
    if (column.dataIndex === 'cutOff') return 'Cut Off';
    if (column.dataIndex === 'routeCutOff') return 'Route Cut Off';
    if (column.dataIndex === 'startOfDayEmail') return 'SOC';
    if (column.dataIndex === 'sendEmail') return 'Send Email';
    if (column.dataIndex === 'accountOwner') return 'Account Owner';
    if (column.dataIndex === 'modifiedBy') return 'Last Modified';
    if (column.dataIndex === 'Actions') return 'Actions';
    
    return typeof column.title === 'string' ? column.title : column.dataIndex;
  };

  // Filter columns based on context - hide End Date when not viewing dropouts
  // const filteredColumns = baseColumns.filter(column => {
  //   if (column.dataIndex === 'endDate') {
  //     return isViewDropOutVisible; // Only show End Date when viewing dropouts
  //   }
  //   return true; // Show all other columns
  // });

  const filteredColumns = baseColumns.filter(column => {
    if (column.dataIndex === 'endDate') {
      // For ManageOuts screen: only show endDate when viewing dropouts
      if (isManageOutsScreen) {
        return isViewDropOutVisible;
      }
      // For all other screens (ManageSubstitutions, etc.): always show endDate
      return true;
    }
    return true; // Show all other columns
  });

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'transparent',
          zIndex: 99998
        }}
        onClick={onClose}
      />
     
      <div
        ref={modalRef}
        style={{
          position: 'absolute',
          top: position.top,
          left: position.left,
          backgroundColor: '#ffffff',
          borderRadius: isOgmSubsTable ? '0 0 6px 6px' : '6px',
          padding: 0,
          width: '220px',
          maxHeight: '400px',
          overflow: 'hidden',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
          display: 'flex',
          flexDirection: 'column',
          border: '1px solid #d9d9d9',
          borderTop: isOgmSubsTable ? 'none' : '1px solid #d9d9d9',
          zIndex: 99999,
          ...(isOgmSubsTable && {
            margin: 0,
            transform: 'none',
            marginTop: '-1px'
          })
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{
          padding: '16px 16px 12px 16px',
          borderBottom: '1px solid #f0f0f0',
          backgroundColor: '#ffffff',
          borderTopLeftRadius: isOgmSubsTable ? 0 : '6px',
          borderTopRightRadius: isOgmSubsTable ? 0 : '6px'
        }}>
          <h4 style={{
            margin: 0,
            fontSize: '14px',
            fontWeight: 400,
            color: '#000000',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
          }}>
            Select columns
          </h4>
        </div>

        <div style={{
          flex: 1,
          overflowY: 'auto',
          padding: '8px 0',
          backgroundColor: '#ffffff'
        }}>
          {filteredColumns.map((column, index) => {
            const isActionsColumn = column.dataIndex === 'ruleType' || column.dataIndex === 'Actions';
            const columnTitle = getColumnTitle(column);
            const isLastItem = index === filteredColumns.length - 1;
           
            return (
              <div
                key={column.dataIndex}
                style={{
                  padding: '10px 16px',
                  borderBottom: isLastItem ? 'none' : '1px solid #f5f5f5',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <Checkbox
                  checked={selectedColumns.includes(column.dataIndex)}
                  disabled={isActionsColumn}
                  onChange={(e) => handleColumnToggle(column.dataIndex, e.target.checked)}
                  style={{
                    margin: 0
                  }}
                />
                <span style={{
                  marginLeft: '8px',
                  fontSize: '14px',
                  color: isActionsColumn ? '#bfbfbf' : '#000000',
                  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  fontWeight: 400,
                  lineHeight: '22px'
                }}>
                  {columnTitle}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default ColumnSelectionModal;